/*
 * The footer's live half: news, events and help topics from the ABU API, and
 * the newsletter signup that posts back to it.
 *
 * One request fills all three columns, and the labels come back translated, so
 * this theme holds no copy of ABU's six languages.
 *
 * The signup goes to api.abuniverse.com rather than to Shopify's own customer
 * form: the newsletter list lives in the ABU signup app, and two lists is how a
 * customer ends up unsubscribed from one of them.
 */
(function () {
  var root = document.querySelector('[data-abu-footer]');

  if (!root) {
    return;
  }

  var api = (root.dataset.abuApi || 'https://api.abuniverse.com').replace(/\/+$/, '');
  var region = root.dataset.abuRegion || '';
  var LOCALES = ['en', 'de', 'es', 'fr', 'nl', 'ja'];
  var asked = (root.dataset.abuLocale || 'en').slice(0, 2).toLowerCase();
  var locale = LOCALES.indexOf(asked) === -1 ? 'en' : asked;
  var pageLocale = root.dataset.abuLocale || 'en';
  var labels = {};
  var turnstile = { siteKey: '', required: false, id: null, token: '', pending: null };

  function column(name) {
    return root.querySelector('[data-abu-column="' + name + '"]');
  }

  function list(name) {
    return root.querySelector('[data-abu-list="' + name + '"]');
  }

  function heading(name) {
    return root.querySelector('[data-abu-heading="' + name + '"]');
  }

  /**
   * A column stays out of the page until there is something in it: an empty
   * heading over a blank space reads as a footer that failed.
   */
  function show(name) {
    var found = column(name);

    if (found) {
      found.hidden = false;
    }
  }

  function link(href, text, className) {
    var anchor = document.createElement('a');
    anchor.className = className || 'abu-footer__link';
    anchor.href = href;
    anchor.textContent = text;

    return anchor;
  }

  function item(children) {
    var li = document.createElement('li');
    li.className = 'abu-footer__item';
    children.forEach(function (child) {
      li.appendChild(child);
    });

    return li;
  }

  function meta(text) {
    var span = document.createElement('span');
    span.className = 'abu-footer__meta';
    span.textContent = text;

    return span;
  }

  function shortDate(value) {
    try {
      return new Intl.DateTimeFormat(pageLocale, { day: 'numeric', month: 'short' }).format(new Date(value));
    } catch (error) {
      return '';
    }
  }

  function day(value) {
    try {
      return new Intl.DateTimeFormat(pageLocale, { day: 'numeric' }).format(new Date(value));
    } catch (error) {
      return '';
    }
  }

  function month(value) {
    try {
      return new Intl.DateTimeFormat(pageLocale, { month: 'short' }).format(new Date(value));
    } catch (error) {
      return '';
    }
  }

  /*
   * Four of each: with four equal columns there is room for a fourth line, and
   * a footer that shows more of what is on is worth the height.
   */
  var SHOWN = 4;

  function renderNews(posts, all, label) {
    var target = list('news');

    if (!target || !posts.length) {
      return;
    }

    target.replaceChildren();

    posts.slice(0, SHOWN).forEach(function (post) {
      /*
       * The whole row is the link, date included. With the date outside it, a
       * reader hovering the line under the headline got no pointer and no
       * click - the row looked inert exactly where it looks most clickable.
       */
      var anchor = link(post.url, '');

      var line = document.createElement('span');
      line.className = 'abu-footer__title';
      line.textContent = post.title;
      anchor.appendChild(line);

      if (post.publishedAt) {
        anchor.appendChild(meta(shortDate(post.publishedAt)));
      }

      target.appendChild(item([anchor]));
    });

    if (all && label) {
      target.appendChild(item([link(all, label, 'abu-footer__more')]));
    }

    show('news');
  }

  function renderEvents(events, all, label, disclaimer) {
    var target = list('events');

    if (!target || !events.length) {
      return;
    }

    target.replaceChildren();

    events.slice(0, SHOWN).forEach(function (event) {
      /*
       * The date as a chip beside the title: an event is a date first, and a
       * list of them reads as a calendar rather than as more headlines. The
       * column is sized for it.
       */
      var chip = document.createElement('span');
      chip.className = 'abu-footer__chip';

      var chipDay = document.createElement('span');
      chipDay.className = 'abu-footer__chip-day';
      chipDay.textContent = day(event.startsAt);

      var chipMonth = document.createElement('span');
      chipMonth.className = 'abu-footer__chip-month';
      chipMonth.textContent = month(event.startsAt);

      chip.appendChild(chipDay);
      chip.appendChild(chipMonth);

      var title = document.createElement('span');
      title.className = 'abu-footer__title';
      title.textContent = event.title;

      var lines = document.createElement('span');
      lines.className = 'abu-footer__lines';
      lines.appendChild(title);

      if (event.place) {
        lines.appendChild(meta(event.place));
      }

      /* The chip is part of the event, so it is part of the link. */
      var anchor = link(event.url, '');
      anchor.className = 'abu-footer__link abu-footer__event';
      anchor.appendChild(chip);
      anchor.appendChild(lines);

      target.appendChild(item([anchor]));
    });

    if (all && label) {
      target.appendChild(item([link(all, label, 'abu-footer__more')]));
    }

    var shownCommunity = events.slice(0, SHOWN).some(function (event) {
      return !event.isOurs;
    });

    if (disclaimer && shownCommunity) {
      target.appendChild(item([meta(disclaimer)]));
    }

    show('events');
  }

  /**
   * The contact page, for this region and language. The markup ships a link
   * already, so a fetch that never lands leaves a working one behind.
   */
  function renderContactLink(contact) {
    var anchor = root.querySelector('[data-abu-contact-link]');

    if (anchor && contact.contactUrl) {
      anchor.href = contact.contactUrl;
    }
  }

  /**
   * Where to buy, under the shop's own collections.
   */
  function renderShopLinks(links) {
    var target = list('shop');

    if (!target) {
      return;
    }

    links
      .filter(function (entry) {
        return entry.group === 'shop';
      })
      .forEach(function (entry) {
        target.appendChild(item([link(entry.url, entry.label)]));
      });
  }

  /*
   * The accounts ABU keeps, in a fixed order. Each mark is drawn here: the
   * theme's own icons are a set from before X was X, and an outline bird where
   * the mark should be reads as a stale footer.
   */
  var SOCIAL = [
    {
      key: 'twitter',
      label: 'X',
      path: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z',
    },
    {
      key: 'instagram',
      label: 'Instagram',
      path: 'M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.336 3.608 1.311.975.975 1.249 2.242 1.311 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.336 2.633-1.311 3.608-.975.975-2.242 1.249-3.608 1.311-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.336-3.608-1.311-.975-.975-1.249-2.242-1.311-3.608C2.175 15.584 2.163 15.204 2.163 12s.012-3.584.07-4.85c.062-1.366.336-2.633 1.311-3.608.975-.975 2.242-1.249 3.608-1.311C8.416 2.175 8.796 2.163 12 2.163zm0 1.802c-3.15 0-3.494.012-4.72.068-1.05.048-1.81.22-2.32.73-.51.51-.682 1.27-.73 2.32-.056 1.226-.068 1.57-.068 4.72s.012 3.494.068 4.72c.048 1.05.22 1.81.73 2.32.51.51 1.27.682 2.32.73 1.226.056 1.57.068 4.72.068s3.494-.012 4.72-.068c1.05-.048 1.81-.22 2.32-.73.51-.51.682-1.27.73-2.32.056-1.226.068-1.57.068-4.72s-.012-3.494-.068-4.72c-.048-1.05-.22-1.81-.73-2.32-.51-.51-1.27-.682-2.32-.73-1.226-.056-1.57-.068-4.72-.068zm0 3.063a5.472 5.472 0 1 1 0 10.944 5.472 5.472 0 0 1 0-10.944zm0 1.802a3.67 3.67 0 1 0 0 7.34 3.67 3.67 0 0 0 0-7.34zm5.688-3.09a1.278 1.278 0 1 1 0 2.556 1.278 1.278 0 0 1 0-2.556z',
    },
    {
      key: 'facebook',
      label: 'Facebook',
      path: 'M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.51 1.49-3.9 3.77-3.9 1.1 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.78-1.63 1.57v1.88h2.78l-.45 2.91h-2.33V22c4.78-.76 8.44-4.92 8.44-9.94z',
    },
    {
      key: 'reddit',
      label: 'Reddit',
      path: 'M22 11.82a2.1 2.1 0 0 0-3.55-1.5 10.3 10.3 0 0 0-5.1-1.6l.98-3.1 2.63.6a1.52 1.52 0 1 0 .18-.9l-3.1-.7a.45.45 0 0 0-.52.3l-1.17 3.7a10.3 10.3 0 0 0-5.2 1.6A2.1 2.1 0 1 0 4.2 13.7a3.9 3.9 0 0 0-.05.6c0 3.1 3.52 5.6 7.85 5.6s7.85-2.5 7.85-5.6a3.9 3.9 0 0 0-.05-.6A2.1 2.1 0 0 0 22 11.82zM8.3 13.2a1.25 1.25 0 1 1 1.25 1.25A1.25 1.25 0 0 1 8.3 13.2zm7.17 3.86a5.2 5.2 0 0 1-3.47 1.08 5.2 5.2 0 0 1-3.47-1.08.4.4 0 0 1 .55-.58 4.4 4.4 0 0 0 2.92.86 4.4 4.4 0 0 0 2.92-.86.4.4 0 0 1 .55.58zm-.98-2.61a1.25 1.25 0 1 1 1.25-1.25 1.25 1.25 0 0 1-1.25 1.25z',
    },
  ];

  function renderSocial(social) {
    var target = root.querySelector('[data-abu-social]');

    if (!target) {
      return;
    }

    var accounts = SOCIAL.filter(function (account) {
      return social[account.key];
    });

    if (!accounts.length) {
      return;
    }

    target.replaceChildren();

    accounts.forEach(function (account) {
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'currentColor');
      svg.setAttribute('aria-hidden', 'true');

      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', account.path);
      svg.appendChild(path);

      var anchor = document.createElement('a');
      anchor.href = social[account.key];
      anchor.target = '_blank';
      anchor.rel = 'noopener noreferrer';
      anchor.setAttribute('aria-label', account.label);
      anchor.appendChild(svg);

      var li = document.createElement('li');
      li.appendChild(anchor);
      target.appendChild(li);
    });

    var wrapper = root.querySelector('[data-abu-follow]');

    if (wrapper) {
      wrapper.hidden = false;
    }
  }

  function setHeading(name, text) {
    var found = heading(name);

    if (found && text) {
      found.textContent = text;
    }
  }

  var TURNSTILE_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
  var turnstileScript = null;

  function loadTurnstile() {
    if (window.turnstile) {
      return Promise.resolve();
    }

    if (turnstileScript) {
      return turnstileScript;
    }

    turnstileScript = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = TURNSTILE_SRC;
      script.async = true;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return turnstileScript;
  }

  /**
   * Render the challenge the first time somebody goes for the field.
   *
   * Not on page load: this is a footer on every page of a shop, and a widget
   * on all of them costs every visitor a request to Cloudflare to protect a
   * form almost none of them will use. `interaction-only` keeps it invisible
   * unless Cloudflare actually wants to ask something.
   */
  function armTurnstile(form) {
    if (!turnstile.required || !turnstile.siteKey || turnstile.id !== null || turnstile.pending) {
      return turnstile.pending || Promise.resolve();
    }

    var slot = form.querySelector('[data-abu-turnstile]');

    if (!slot) {
      return Promise.resolve();
    }

    turnstile.pending = loadTurnstile()
      .then(function () {
        turnstile.id = window.turnstile.render(slot, {
          sitekey: turnstile.siteKey,
          appearance: 'interaction-only',
          language: pageLocale.slice(0, 2),
          callback: function (token) {
            turnstile.token = token;
          },
          'expired-callback': function () {
            turnstile.token = '';
          },
          'error-callback': function () {
            turnstile.token = '';
          },
        });
      })
      .catch(function () {
        /* Unreachable: the signup is attempted without a token, and the API
           decides what to do about that. */
      });

    return turnstile.pending;
  }

  /**
   * The signup. The address goes to our API, which holds the list's token and
   * hands the address on; the reader is told whichever of the list's answers
   * came back, in their own language.
   */
  function wireSignup() {
    var form = root.querySelector('[data-abu-signup]');

    if (!form) {
      return;
    }

    var field = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var message = root.querySelector('[data-abu-signup-message]');

    function say(text, failed) {
      if (!message) {
        return;
      }

      message.textContent = text;
      message.hidden = !text;
      message.className = failed ? 'abu-footer__message abu-footer__message--failed' : 'abu-footer__message';
    }

    if (field) {
      field.addEventListener('focus', function () {
        armTurnstile(form);
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (!field || !field.value) {
        return;
      }

      if (button) {
        button.disabled = true;
      }

      say('', false);

      /*
       * A reader who tabbed straight to the button has not armed the challenge
       * yet, so it is armed now and given a moment to answer before the
       * address is sent.
       */
      Promise.resolve(armTurnstile(form))
        .then(function () {
          return waitForToken();
        })
        .then(function () {
          return send();
        });
    });

    /**
     * Up to five seconds for a token, in quarter seconds. Beyond that the
     * address goes without one and the API turns it away with something the
     * reader can act on, which beats a button that never comes back.
     */
    function waitForToken() {
      if (!turnstile.required || !turnstile.id || turnstile.token) {
        return Promise.resolve();
      }

      return new Promise(function (resolve) {
        var waited = 0;
        var timer = setInterval(function () {
          waited += 250;

          if (turnstile.token || waited >= 5000) {
            clearInterval(timer);
            resolve();
          }
        }, 250);
      });
    }

    function send() {
      var body = { email: field.value, region: region, source: 'store-footer' };

      if (turnstile.token) {
        body.turnstile_token = turnstile.token;
      }

      return fetch(api + '/newsletter', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (response) {
          return response
            .json()
            .catch(function () {
              return {};
            })
            .then(function (payload) {
              return { ok: response.ok, payload: payload };
            });
        })
        .then(function (answer) {
          if (!answer.ok) {
            say(answer.payload.message || labels.failed || '', true);

            return;
          }

          form.reset();
          say(answer.payload.message || labels.subscribed || '', false);
        })
        .catch(function () {
          say(labels.failed || '', true);
        })
        .then(function () {
          if (button) {
            button.disabled = false;
          }

          /* A token is good for one submission. */
          turnstile.token = '';

          if (turnstile.id !== null && window.turnstile) {
            window.turnstile.reset(turnstile.id);
          }
        });
    }
  }

  wireSignup();

  if (!region) {
    return;
  }

  fetch(api + '/footer?region=' + encodeURIComponent(region) + '&locale=' + encodeURIComponent(locale), {
    headers: { Accept: 'application/json' },
  })
    .then(function (response) {
      return response.ok ? response.json() : null;
    })
    .then(function (payload) {
      var data = payload && payload.data;

      if (!data) {
        return;
      }

      labels = data.labels || {};

      if (data.turnstile) {
        turnstile.siteKey = data.turnstile.siteKey || '';
        turnstile.required = data.turnstile.required === true;
      }

      setHeading('shop', labels.shop);
      setHeading('news', labels.news);
      setHeading('events', labels.events);

      renderNews(data.news || [], data.newsUrl, labels.allNews);
      renderEvents(data.events || [], data.eventsUrl, labels.allEvents, labels.eventsDisclaimer);
      renderShopLinks(data.links || []);
      renderSocial(data.social || {});
      renderContactLink(data.contact || {});
    })
    .catch(function () {
      /* The columns keep whatever the theme rendered into them. */
    });
})();
